import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class getFilterProduct extends Event {
    eventName = 'oms_getFilterProduct';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get filters
     * 
     * @param {string} data.client_id -  id given for client
     * @param {string} data.url - optional - unique id for request
     * @param {string} data.limit -  limit of response
     * @param {string} data.start -  start of response
   
 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let url = data.url;
        let thisObj = this;
        let start = data.start;
        let category_id = data.category_id;
        let locationId = new LocalStorage.CurrentLocation(clientId).getData();
        
        // request data
        data.endPoint = application_settings.endPoints.getFilterProductUrl + '?' + url;
        data.data = {
            client_id: clientId,
            location_id: locationId,
            limit: data.limit,
            start: start,
            category_id: category_id
        };

        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data);
            }
        });
        
    }
}

export default getFilterProduct;